export default (string) => {
  return string.toString().toLowerCase().replace(/\W/g,'-');
}